import * as Actions from "auth/store/actions";

const initialState = {
  success: false,
  isConfirmLoading: false,
  errorConfirm: null,
  data: null,
};

const confirm = (state = initialState, action) => {
  switch (action.type) {
    case Actions.CONFIRM_FETCH_START: {
      return {
        ...initialState,
        isConfirmLoading: true,
      };
    }
    case Actions.CONFIRM_FETCH_SUCCESS: {
      return {
        ...initialState,
        success: true,
        isConfirmLoading: false,
        data: action.payload,
      };
    }
    case Actions.CONFIRM_FETCH_FAILURE: {
      return {
        success: false,
        isConfirmLoading: false,
        errorConfirm: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default confirm;
